import { render, staticRenderFns } from "./find-form-simple.vue?vue&type=template&id=1b35acfa&"
import script from "./find-form-simple.vue?vue&type=script&lang=js&"
export * from "./find-form-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports